import React, { PropsWithChildren } from 'react';
import { useDispatch } from 'react-redux';

import { ButtonLink } from '@/components';
import { logout } from '@/model/global/actions';

export interface LogoutLinkProps extends PropsWithChildren<unknown> {
  'data-test'?: string;
  className?: string;
}

export const LogoutLink: React.FC<LogoutLinkProps> = ({ className, children, 'data-test': dataTest }) => {
  const dispatch = useDispatch();
  return (
    <ButtonLink
      data-test={dataTest}
      type="secondary"
      onClick={async (): Promise<void> => {
        await logout()(dispatch);
      }}
      className={className}
    >
      {children}
    </ButtonLink>
  );
};

export default LogoutLink;
